(function (w) {
	'use strict';

	function MxLocalizationPropertyShort(options) {
		var that = this;

		options = options || {};

		Object.defineProperty(that, 'key', {
			writable: true,
			enumerable: true,
			value: options.Key || options.Id,
		});
		Object.defineProperty(that, 'value', {
			writable: true,
			enumerable: true,
			value: options.Value,
		});
		Object.defineProperty(that, 'description', {
			writable: true,
			enumerable: true,
			value: options.Description,
		});

		Object.defineProperty(that, 'lower', {
			enumerable: false,
			get: function () {
				return this.value.toLowerCase();
			},
		});
	}

	MxLocalizationPropertyShort.prototype.toJSON = function () {
		return {
			Key: this.key,
			Value: this.value,
			Description: this.description,
		};
	};

	function MxLocalizationProperty(options) {
		var that = this;

		options = options || {};

		mx.SolutionBuilderAgent.LocalizationPropertyShort.call(that, options);

		var translations = [];

		if (options.Translations && options.Translations.length) {
			translations = options.Translations.map(function (item) {
				return new MxLocalizationPropertyTranslation(item);
			});
		}
		Object.defineProperty(that, 'translations', {
			writable: true,
			enumerable: true,
			value: translations,
		});
	}

	function MxLocalizationPropertyTranslation(options) {
		var that = this;

		options = options || {};

		Object.defineProperty(that, 'value', {
			writable: true,
			enumerable: true,
			value: options.Value || '',
		});
		Object.defineProperty(that, 'lcid', {
			writable: true,
			enumerable: true,
			value: options.Lcid,
		});
	}

	w.mx = w.mx || {};
	w.mx.SolutionBuilderAgent = w.mx.SolutionBuilderAgent || {};
	w.mx.SolutionBuilderAgent.LocalizationPropertyShort = MxLocalizationPropertyShort;
	w.mx.SolutionBuilderAgent.LocalizationProperty = MxLocalizationProperty;
	w.mx.SolutionBuilderAgent.LocalizationPropertyTranslation = MxLocalizationPropertyTranslation;
})(window);
